module.exports = __webpack_public_path__ + "img/CH00-004-005.d0bcbef4.jpg";